<template>

  <div class="b-field-view">

    <el-row class="">
      <el-col :span="6">

        {{field.title}}

      </el-col>
      <el-col :span="18">

        <div v-if="isEncrypted">

          <crypt-value :value="value" />

        </div>
        <div v-else>

          <div v-if="field.fieldType === 'uploader'">

            <div v-for="file, n in value">
              <a target="_blank" :href="apiUrl + '/v1/attachments/' + file._id">File {{n + 1}}</a>
            </div>
          </div>
          <div v-else-if="field.fieldType === 'radio'">
            <i class="fa fa-dot-circle-o" aria-hidden="true"></i> {{value}}
          </div>
          <div v-else-if="field.fieldType === 'checkbox'">
            <div v-for="val in value">
              <i class="fa fa-check-square-o" aria-hidden="true"></i> {{val}}
            </div>
          </div>
          <div v-else>
            {{value}}
          </div>

        </div>
      </el-col>
    </el-row>

  </div>
</template>
<style lang="scss">
  .b-field-view {
    .el-row {
      padding: 10px 0;
      border-bottom: 1px solid #f2f2f2;
    }
  }
</style>
<script>
  import cryptValue from './cryptValue';
  export default {
    components: {
      cryptValue
    },
    props: [ 'field', 'value', 'isEncrypted' ],
    data() {
      return {
        hasKey: false
      }
    }
  };
</script>



// WEBPACK FOOTER //
// fieldView.vue?3315ac99